import React, { useContext, useState } from "react"
import { Button } from "react-bootstrap"

import { logToServer } from "../../../../ErrorBoundary"
import { updateObject } from "../../../../Loaders"
import { FermManagementConfigContext } from "../../../../config/FermManagementConfigProvider"
import StopRunModal from "./"

export default function StopRunButton({
  run,
  intl,
  onHide,
  onSuccess,
  extraSm = true,
  flexStart = true,
  linkRunName = true,
}) {
  const context = useContext(FermManagementConfigContext)
  const [verifySubmitModal, setVerifySubmitModal] = useState(false)
  const [runStopWarn, setRunStopWarn] = useState(false)
  const { permissions = [] } = context
  const needInoculationInfo = run?.missing_parental_information
  const stopRun = (e, run, onErr) => {
    e.preventDefault()
    updateObject(`/warehouse/runs/${run.id}/finish/`, {})
      .then((_) => {
        onSuccess()
      })
      .catch((err) => {
        onErr()
        console.error(err)
        logToServer(err)
        setRunStopWarn(err)
      })
  }

  return (
    <>
      {verifySubmitModal && (
        <StopRunModal
          intl={intl}
          show={verifySubmitModal}
          onHide={() => {
            onHide && onHide()
            setVerifySubmitModal(false)
          }}
          submitForm={stopRun}
          selectedRun={run}
          warning={runStopWarn}
          linkRunName={linkRunName}
        />
      )}
      {!run.placeholder &&
        permissions.includes("end_fermentation_run") &&
        !run?.finished_on &&
        !needInoculationInfo &&
        run.status !== "Archiving" && (
          <Button
            variant={"outline-primary"}
            size={extraSm ? "sm" : ""}
            className={extraSm ? "btn-extra-sm" : ""}
            style={flexStart ? { alignSelf: "flex-start" } : {}}
            disabled={needInoculationInfo}
            onClick={(e) => {
              e.preventDefault()
              setVerifySubmitModal(true)
            }}
          >
            <span className={"fa fa-minus-circle"} />
            &nbsp;&nbsp;
            {intl.formatMessage({
              id: "fermmanagement.stop.run",
              defaultMessage: "Stop Run",
            })}
          </Button>
        )}
    </>
  )
}
